import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';
import { ActivatedRoute, Router } from '@angular/router';
import { AppliedJobsComponent } from './applied-jobs/applied-jobs.component';
import { RecommendedJobsComponent } from './recommended-jobs/recommended-jobs.component';
import { SavedJobsComponent } from './saved-jobs/saved-jobs.component';
import { BreadcrumbComponent, BreadcrumbItem } from '../../components/shared/breadcrumb/breadcrumb.component';

const TAB_SLUGS = ['applied', 'saved', 'recommended'] as const;
type TabSlug = typeof TAB_SLUGS[number];

@Component({
  selector: 'app-jobs-page',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTabsModule,
    TranslocoModule,
    AppliedJobsComponent,
    RecommendedJobsComponent,
    SavedJobsComponent,
    BreadcrumbComponent
  ],
  templateUrl: './jobs-page.component.html',
  styleUrls: ['./jobs-page.component.scss']
})
export class JobsPageComponent implements OnInit {
  selectedIndex = 0;
  readonly tabs = TAB_SLUGS;

  constructor(private readonly route: ActivatedRoute, private readonly router: Router) {}

  get breadcrumbItems(): BreadcrumbItem[] {
    const items: BreadcrumbItem[] = [
      { labelKey: 'breadcrumbs.home', link: '/' },
      { labelKey: 'nav.myJobs', link: '/jobs' },
    ];
    const slug = this.tabs[this.selectedIndex];
    if (slug) {
      items.push({ labelKey: 'pages.jobs.tabs.' + slug });
    }
    return items;
  }

  onMobileSelectChange(value: string | number): void {
    const idx = typeof value === 'string' ? Number(value) : value;
    if (!Number.isNaN(idx)) this.onTabChange(idx);
  }

  ngOnInit(): void {
    const tab = this.route.snapshot.queryParamMap.get('tab') as TabSlug | null;
    const index = tab ? TAB_SLUGS.indexOf(tab) : -1;
    this.selectedIndex = index >= 0 ? index : 0;
  }

  onTabChange(index: number): void {
    this.selectedIndex = index;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: TAB_SLUGS[index] },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}